import styled from "styled-components";

export const Wrapper = styled.div`
    grid-row: ${({$isCollapsed}) => ($isCollapsed ? "2" : "3")};;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Switcher = styled.div`
    position: relative;
    z-index: 10;
    height: 37px;
    background: #23262D;
    border-radius: 100px;
    display: grid;
    grid-template-columns: auto auto;
    gap: 5px;
    align-items: center;
    cursor: pointer;
    padding: 0 5px;
    box-sizing: border-box;
`;

export const IndexedText = styled.span`
    z-index: 12;
`;

export const SwitcherPill = styled.div`
    grid-column: ${({ $cmsActive }) => ($cmsActive ? "2" : "1")};;
    z-index: 11;
    padding: 5px;
    background: #8540DD;
    color: var(--Basic-300);
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
`;

export const SwitcherPillInactive = styled.div`
    grid-column: ${({$cmsActive}) => ($cmsActive ? "1" : "2")};;
    z-index: 11;
    color: #93939e;
    padding: 5px;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 0;
`;